import { Pagination } from "antd";
import {
  PaginationEllipsis,
  PaginationNext,
  PaginationPrev,
} from "themes/Icon";
import "./pagination.scss";

function PaginationComp({
  total = 100,
  onChange,
  currentPageNo = 1,
  isLoading,
}) {
  const locale = {
    jump_to: "Page",
    jump_to_confirm: "confirm",
    page: `of ${Math.ceil(total / 10)}`,
  };
  const customItemRender = (page, type, originalElement) => {
    if (type === "prev") {
      return <PaginationPrev />;
    }
    if (type === "next") {
      return <PaginationNext />;
    }
    if (type === "jump-prev" || type === "jump-next") {
      return <PaginationEllipsis />;
    }
    return originalElement;
  };

  const handlePageChange = (page) => {
    onChange(page);
  };

  return (
    <>
      <Pagination
        key={currentPageNo}
        current={currentPageNo}
        className={`pagination-comp ${isLoading ? "disabled" : ""}`}
        locale={locale}
        showQuickJumper
        showSizeChanger={false}
        total={total}
        itemRender={customItemRender}
        onChange={handlePageChange}
      />
    </>
  );
}

export default PaginationComp;
